import React from 'react'
import { observer } from 'mobx-react-lite'
import { IntegrationSyncDropdown } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/IntegrationSyncDropdown/IntegrationSyncDropdown'
import { type IntegrationSettingsSyncStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationSettingsSyncStore'
import { type IZohoSettingsDict } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationZohoSettings/types'
import { IntegrationSyncType } from 'pages/settings/pages/integrations/pages/integrationSettings/lib'
import styles from './styles.module.scss'

type IIntegrationZohoSettingsSyncProps = {
  store: IntegrationSettingsSyncStore<IZohoSettingsDict>
}

export const IntegrationZohoSettingsSync: React.FC<IIntegrationZohoSettingsSyncProps> = observer(
  ({ store }) => {
    const selectItems = store.selectItems.map((item) =>
      item.id === IntegrationSyncType.oneWay ? { ...item, disabled: true } : item
    )

    return (
      <div className={styles.root}>
        <IntegrationSyncDropdown
          integrationIcon={'logoZoho'}
          iconHeight={60}
          isTwoWaySync={true}
          syncType={IntegrationSyncType.twoWay}
          setSyncType={() => {}}
          selectItems={selectItems}
        />
      </div>
    )
  }
)
